import React from 'react';

function Inventory() {

  return (
    <React.Fragment>
      <h1>Inventory</h1>
    </React.Fragment>
  );
}

export default Inventory;
